import React from 'react'
import useStyles from './ReportsSelect.styles'
import useId from 'modules/reports/hooks/id'
import {FormControl, InputLabel, Select} from '@material-ui/core'

type Option = {
  value: any
  label: React.ReactNode
}

type Props = {
  name: string
  value: any
  options: Option[]
  label: string
  width?: string
  'data-testid': string
}

function ReportsSelect(props: Props) {
  const classes = useStyles()
  const id = useId('reports-dropdown-')
  const {name, value, options, label, width} = props

  function handleChange() {}

  return (
    <FormControl
      className={classes.root}
      variant="outlined"
      size="small"
      style={{width: width || '100%'}}
    >
      <InputLabel htmlFor={id}>{label}</InputLabel>

      <Select
        value={value}
        onChange={handleChange}
        inputProps={{id, name}}
        data-testid={props['data-testid']}
      >
        {options.map(item => (
          <option key={item.value} value={item.value}>
            {label}
          </option>
        ))}
      </Select>
    </FormControl>
  )
}

export default ReportsSelect
